import { computed } from 'mobx';

import { Model } from 'core/model/Model';
import $dictionary from 'app/stores/$dictionary';
import { InterfaceSettingsJson } from 'app/stores/interface/types';

class InterfaceSettings extends Model<InterfaceSettingsJson> {
  get defaults() {
    return { settings: $dictionary.get('interfaceClassification.settingsDefaults') };
  }

  get url() {
    return '/api/ui/interfaces/rules/settings';
  }

  /**
   * Override the isNew check because this particular model doesn't return with an `id`, but instead `company_id`.
   */
  @computed
  get isNew() {
    return false;
  }

  get jsonRoot() {
    return 'settings';
  }

  fetch(): Promise<InterfaceSettingsJson> {
    return super.fetch() as Promise<InterfaceSettingsJson>;
  }
}

export default InterfaceSettings;
